import { GetMessagesResponse } from '@shared/api/rest';
import { ReactNode } from 'react';

interface HeaderPrintableContentType {
  children?: ReactNode;
  message: GetMessagesResponse;
}

export const MessagePrintableContent = (props: HeaderPrintableContentType) => {
  return (
    <div className='messages-container'>
      <div className='messages-subject'>{props.message.Subject}</div>
      <div className='messages-body'>{props.message.Body}</div>
    </div>
  );
};
